import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide, } from 'swiper/react';
import { A11y, Pagination } from 'swiper/modules';
import 'swiper/css';

import './UpcomingEventsCarousel.css';
import './UpcomingEvents.css';

import { SlCalender } from 'react-icons/sl';
import { IoMdStopwatch } from 'react-icons/io';
import { LiaGlassCheersSolid } from 'react-icons/lia';
import { PiUsers } from 'react-icons/pi';
import { IoLocationOutline } from "react-icons/io5";

const UpcomingEventsCarousel = ({ leads = [], setActiveIndex, setModalOpen }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const swiperRef = useRef(null);

  const getTotalGuests = (item) => {
    const male = parseInt(item.male || 0, 10);
    const female = parseInt(item.female || 0, 10);
    const kids = parseInt(item.kids || 0, 10);
    return male + female + kids;
  };

  // Set first slide as active on mount/update
  useEffect(() => {
    if (leads.length && leads[0]?.id) {
      if (setActiveIndex) {
        setActiveIndex({ id: leads[0].id, type: leads[0].type });
      }
    }
  }, [leads, setActiveIndex]);

  console.log("setActiveIndex", currentIndex);



  if (!leads.length) {
    return <div className="ue-no-events">No upcoming events</div>;
  }

  return (
    <div className="ue-custom-carousel">
      <Swiper
        modules={[Pagination]}
        spaceBetween={10}
        slidesPerView={"auto"}      // auto width per slide
        centeredSlides={true}       // active card in center
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onSlideChange={(swiper) => {
          setCurrentIndex(swiper.activeIndex);
          const activeItem = leads[swiper.activeIndex];
          if (setActiveIndex && activeItem?.id) {
            setActiveIndex({ id: activeItem.id, type: activeItem.type }); 
          }
        }}
        navigation={false}
        pagination={{
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 5,
        }}
        className="upcoming-events-header-swiper"
      >
        {leads.map((event, index) => (
          <SwiperSlide
            key={index}
            className={`upcoming-events-header-slide-swiper-slide ${leads.length === 1 ? "single-slide" : ""}`}
          >
            <p className="upcoming-events-header-title">
              {event?.type === "table" ? "Table Booking" : "Package Booking"}
            </p>

            <div className="upcoming-events-header-content">
              <div className="upcoming-events-header-list">
                <p>
                  <SlCalender /> Party Date:{' '}
                </p>
                <p>
                  <span className="upcoming-events-header-list-span">
                    {event?.party_date}
                  </span>
                </p>
              </div>

              <div className="upcoming-events-header-list">
                <p>
                  <IoMdStopwatch /> Party Time Slot:{' '}
                </p>
                <p>
                  <span className="upcoming-events-header-list-span">
                    {event?.party_time}
                  </span>
                </p>
              </div>

              {event?.type === "table" && (
                <div className="upcoming-events-header-list">
                  <p>
                    <IoLocationOutline /> Location:{' '}
                  </p>
                  <p>
                    <span className="upcoming-events-header-list-span">
                      {`${event?.area}, ${event?.city}`.length > 15
                        ? `${`${event?.area}, ${event?.city}`.slice(0, 15)}...`
                        : `${event?.area}, ${event?.city}`}
                    </span>
                  </p>
                </div>
              )}

              {event?.type === "package" && (
                <div className="upcoming-events-header-list">
                  <p>
                    <LiaGlassCheersSolid /> Package Type:{' '}
                  </p>
                  <p>
                    <span className="upcoming-events-header-list-span">
                      {event?.title?.length > 15
                        ? `${event?.title?.slice(0, 15)}...`
                        : event?.title}
                    </span>
                  </p>
                </div>
              )}

              <div className="upcoming-events-header-list">
                <p>
                  <PiUsers /> Pax:{' '}
                </p>
                <p>
                  <span className="upcoming-events-header-list-span">
                    {getTotalGuests(event)} Guests
                  </span>
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default UpcomingEventsCarousel;
